import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";


async function getByRegister(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/catatan-pemberian-obat`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
    return response.data;
}

async function create(data:any) {
  const response = await http.postData("/catatan-pemberian-obat", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });

  return response.data;
}

async function update(id: number,data: any) {
  const response = await http
    .putData(`/catatan-pemberian-obat/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function addPemberian(data:any) {
  const response = await http.postData("/catatan-pemberian-obat-perawat", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });

  return response.data;
}

async function updatePemberian(id: number,data: any) {
  const response = await http
    .putData(`/catatan-pemberian-obat-perawat/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function hapusPemberian(id: number) {
  const response = await http
    .deleteData(`/catatan-pemberian-obat-perawat/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function stopStartPemberian(id: number,data: any) {
  const response = await http
    .putData(`/catatan-pemberian-obat/${id}/stopped`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function pendingReadback(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/catatan-pemberian-obat/pending-readback`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function autoGenerate(register_id: string | number) {
  const response = await http
    .postData(`/register/${register_id}/catatan-pemberian-obat/auto-generate`, {})
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function getRekap(register_id:  string | number) {
  const response = await http
    .getData(`/register/${register_id}/rekap-catatan-pemberian-obat`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
    return response.data;
}

function print(reg) {
  window.open(`${http.getAPI()}/catatan-pemberian-obat/${reg}/pdf`, "_blank");
}

function printMAR(reg) {
  window.open(`${http.getAPI()}/register/${reg}/lembar-pemberian-obat/pdf`, "_blank");
}

async function getVerifPerawat(register_id:  string | number) {
  const response = await http
    .getData(`/catatan-pemberian-obat-perawat/${register_id}/unverified`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
    return response.data;
}

async function VerifPerawat(data: any) {
  const response = await http
    .putData(`/verifikasi/catatan-pemberian-obat-perawat`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}
async function getVerifDokter(register_id:  string | number) {
  const response = await http
    .getData(`/catatan-pemberian-obat/${register_id}/unverified`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
    return response.data;     
    
}

async function VerifDokter(data: any) {
  const response = await http
    .putData(`/verifikasi/catatan-pemberian-obat`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getPemberianByTgl(register_id:  string | number, tgl:string) {
  const response = await http
    .getData(`/catatan-pemberian-obat-perawat?register_id=${register_id}&date=${tgl}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
    return response.data;     
    
}

export default {
  getByRegister,
  pendingReadback,
  autoGenerate,
  create,
  update,
  addPemberian,
  updatePemberian,
  hapusPemberian,
  stopStartPemberian,
  getRekap,
  print,
  printMAR,
  getVerifPerawat,
  VerifPerawat,
  getVerifDokter,
  VerifDokter,
  getPemberianByTgl
};
